export const LINKEDIN_LINK = 'https://www.linkedin.com/company/abe---assessoria-brasileira-de-empresas/';
export const FACEBOOK_LINK = 'https://www.facebook.com/ABEEmpresas/';
export const TWITTER_LINK = 'https://twitter.com/abe_credito';
export const INSTAGRAM_LINK = 'https://www.instagram.com/abe_assessoria/?hl=pt-br.';
